// src/components/course/CourseCta.js
import React from 'react';
import styled from 'styled-components';
import { colors } from '../../styles/variables';
import { useModal } from '../../contexts/ModalContext';

const CtaSection = styled.section`
  padding: 80px 24px;
  text-align: center;
  background: ${props => props.bgColor ? `linear-gradient(135deg, ${props.bgColor} 0%, ${props.endColor || colors.secondary} 100%)` : colors.secondary};
  color: ${colors.white};
`;

const CtaContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const CtaTitle = styled.h2`
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 16px;
  color: ${colors.white};
`;

const CtaSubtitle = styled.p`
  font-size: 18px;
  margin-bottom: 32px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

const Button = styled.button`
  display: inline-block;
  background-color: ${colors.white};
  color: ${colors.secondary};
  padding: 16px 32px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 18px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  transition: background-color 0.2s, color 0.2s;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.9);
  }
`;

const CourseCta = ({ title, subtitle, bgColor, endColor }) => {
  const { openConsultationModal } = useModal();
  
  return (
    <CtaSection bgColor={bgColor} endColor={endColor}>
      <CtaContainer>
        <CtaTitle>{title}</CtaTitle>
        <CtaSubtitle>{subtitle}</CtaSubtitle>
        <Button onClick={openConsultationModal}>
          교육상담 신청하기
        </Button>
      </CtaContainer>
    </CtaSection>
  );
};

export default CourseCta;